import { useMutation } from "react-query";
import { PartnerApi } from "../../api/partner.api";
import { useSoldSNStore } from "../../store/soldsn.store";

export const useSNList = () => {
  const setSNList = useSoldSNStore((state) => state.setSNList);

  return useMutation(PartnerApi.soldSNCompany, {
    onSuccess: (data) => {
      setSNList(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};
